import React from 'react';
import ProfileDropdownItem from './ProfileDropdownItem';
import './ProfileDropdown.scss';
var ProfileDropdown = function (_a) {
    var children = _a.children, profileInfo = _a.profileInfo, profileDropdownActiveState = _a.profileDropdownActiveState, setProfileDropdownActiveState = _a.setProfileDropdownActiveState;
    var hideOtherDropdowns = function () {
        setProfileDropdownActiveState(!profileDropdownActiveState);
    };
    return (React.createElement("li", { className: "sdds-nav__item sdds-nav__avatar" },
        React.createElement("button", { className: "sdds-nav__avatar-btn", id: "profile_tour_id", onClick: function () { return hideOtherDropdowns(); } },
            React.createElement("span", { className: "".concat(profileDropdownActiveState ? "dark-text" : "light-text", " sdds-headline-05") }, profileInfo.firstName[0] + profileInfo.lastName[0]),
            React.createElement("div", { className: "sdds-nav__avatar-info sdds-nav__avatar-info--mobile" },
                React.createElement("p", { className: "sdds-nav__avatar-title" }, profileInfo.firstName + ' ' + profileInfo.lastName + '(' + profileInfo.role + ')'))),
        React.createElement("ul", { className: "sdds-nav__avatar-menu z-index-1" },
            React.createElement("li", { className: "sdds-nav__avatar-item sdds-nav__avatar-item--large profile-user-name" },
                React.createElement("div", { className: "sdds-nav__avatar-info" },
                    React.createElement("p", { className: "sdds-nav__avatar-title" }, profileInfo.firstName + ' ' + profileInfo.lastName),
                    React.createElement("p", { className: "sdds-nav__avatar-subtitle sub-color" },
                        "(",
                        profileInfo.role,
                        ")"))),
            children)));
};
export { ProfileDropdown, ProfileDropdownItem };
